"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Inbox/LanguageModal/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _peers = require('shared/selectors/peers');










var _translation = require('shared/selectors/translation');
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _noticeBar = require('web/services/context/noticeBar');
var _hooks = require('web/services/hooks');







/* The quick picks on the language row; any other language is one search
 * away under "Other language…". */
const QUICK_PICKS = ['en', 'es']

const FAILED_NOTICE = "Couldn't update translation. Try again."








/* One selectable card; detected recommendations and saved selection differ. */
const LanguageOption = _react.memo.call(void 0, function LanguageOption ({ code, name, isSelected, onPick }) {
  const onClick = _react.useCallback.call(void 0, () => onPick(code), [onPick, code])
  const detected = name.endsWith(' (detected)')
  const displayName = detected ? name.slice(0, -11) : name
  return (
    _react2.default.createElement('button', {
      type: "button",
      className: _classBuilder2.default.call(void 0, 'chat-language-menu--language', isSelected && 'selected'),
      'aria-pressed': isSelected,
      'aria-label': `${name}${isSelected ? ' ✓' : ''}`,
      onClick: onClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}

      , _react2.default.createElement('span', { className: "chat-language-menu--language-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}, displayName)
      , _react2.default.createElement('span', { className: "chat-language-menu--badges", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}
        , detected && _react2.default.createElement('span', { className: "chat-language-menu--badge", __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}, "Detected")
        , isSelected && _react2.default.createElement('span', { className: "chat-language-menu--badge selected" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}, "✓ Selected" )
      )
    )
  )
})

/* Suggestions are recommendations, separate from the saved selection. */
const useLanguageSuggestions = (conversationKey, patientKey) => {
  const [suggested, setSuggested] = _react.useState([])
  _react.useEffect.call(void 0, () => {
    let isCurrent = true
    setSuggested([])
    _actions2.default.getLanguageSuggestions({
      ConversationKey: conversationKey,
      ...(patientKey ? { PatientKey: patientKey } : {}),
    })
      .then(suggestions => {
        if (isCurrent) setSuggested(_translation.getSuggestedLanguages.call(void 0, suggestions))
      })
      .catch(() => null)
    return () => { isCurrent = false }
  }, [conversationKey, patientKey])
  return suggested
}









const LanguageRow = ({ groupLabel, conversationKey, patientKey, language, onPick }) => {
  const suggested = useLanguageSuggestions(conversationKey, patientKey)
  const headingId = _react.useId.call(void 0, )
  const searchId = _react.useId.call(void 0, )
  const [isSearching, setIsSearching] = _react.useState.call(void 0, false)
  const [query, setQuery] = _react.useState.call(void 0, '')
  const searchRef = _react.useRef(null)
  const otherRef = _react.useRef(null)
  const onOtherLanguage = _react.useCallback.call(void 0, () => setIsSearching(searching => !searching), [])
  const onQueryChange = _react.useCallback.call(void 0, 
    (event) => setQuery(event.target.value),
    [],
  )
  const pick = _react.useCallback.call(void 0, (code) => {
    if (isSearching) _optionalChain([otherRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.focus, 'call', _3 => _3()])
    setIsSearching(false)
    setQuery('')
    onPick(code)
  }, [onPick, isSearching])
  _react.useEffect.call(void 0, () => {
    if (isSearching) _optionalChain([searchRef, 'access', _4 => _4.current, 'optionalAccess', _5 => _5.focus, 'call', _6 => _6()])
  }, [isSearching])
  const results = _react.useMemo.call(void 0, 
    () => isSearching ? _translation.searchTranslationLanguages.call(void 0, query) : [],
    [isSearching, query],
  )
  // Suggested/common/current quick choices each appear once. Search remains
  // the full language catalogue, not a change to the saved preference.
  const common = _react.useMemo.call(void 0, () => {
    const codes = [...QUICK_PICKS]
    if (language && !codes.includes(language)) codes.push(language)
    return codes.filter(code => !suggested.some(option => option.code === code))
  }, [language, suggested])

  return (
    _react2.default.createElement('div', { className: "chat-language-menu--picker", role: "group", 'aria-label': groupLabel, __self: this, __source: {fileName: _jsxFileName, lineNumber: 127}}
      , suggested.length > 0 && (
        _react2.default.createElement('section', { className: "chat-language-menu--suggested", 'aria-labelledby': headingId, __self: this, __source: {fileName: _jsxFileName, lineNumber: 129}}
          , _react2.default.createElement('h3', { id: headingId, className: "chat-language-menu--suggested--heading", __self: this, __source: {fileName: _jsxFileName, lineNumber: 130}}, "Suggested")
          , _react2.default.createElement('ul', { className: "chat-language-menu--suggested--list", __self: this, __source: {fileName: _jsxFileName, lineNumber: 131}}
            , suggested.map(({ code, label }) => (
              _react2.default.createElement('li', { key: code, __self: this, __source: {fileName: _jsxFileName, lineNumber: 133}}
                , _react2.default.createElement(LanguageOption, { code: code, name: label, isSelected: language === code, onPick: pick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 134}} )
              )
            ))
          )
        )
      )
      , common.length > 0 && (
        _react2.default.createElement('div', { className: "chat-language-menu--languages", __self: this, __source: {fileName: _jsxFileName, lineNumber: 141}}
          , _react2.default.createElement('span', { className: "chat-language-menu--languages--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 142}}, "Common languages" )
          , common.map(code => (
            _react2.default.createElement(LanguageOption, { key: code, code: code, name: _translation.languageName.call(void 0, code), isSelected: language === code, onPick: pick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 144}} )
          ))
        )
      )
      , _react2.default.createElement('button', {
        ref: otherRef,
        type: "button",
        className: "chat-language-menu--other",
        'aria-label': "Other language…" ,
        'aria-expanded': isSearching,
        'aria-controls': isSearching ? searchId : undefined,
        onClick: onOtherLanguage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 148}}

        , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 157}}, "Other language…" )
        , _react2.default.createElement('span', { 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 158}}, isSearching ? '−' : '+')
      )
      , isSearching && (
        _react2.default.createElement('div', { id: searchId, className: "chat-language-menu--search", __self: this, __source: {fileName: _jsxFileName, lineNumber: 161}}
          , _react2.default.createElement('input', {
            ref: searchRef,
            type: "search",
            className: "chat-language-menu--search--input",
            'aria-label': "Search languages" ,
            placeholder: "Search by language name"   ,
            value: query,
            onChange: onQueryChange, __self: this, __source: {fileName: _jsxFileName, lineNumber: 162}}
          )
          , results.length ? (
            _react2.default.createElement('ul', { className: "chat-language-menu--search--results", 'aria-label': "Languages", __self: this, __source: {fileName: _jsxFileName, lineNumber: 172}}
              , results.map(({ code, name }) => (
                _react2.default.createElement('li', { key: code, __self: this, __source: {fileName: _jsxFileName, lineNumber: 174}}
                  , _react2.default.createElement(LanguageOption, { code: code, name: name, isSelected: language === code, onPick: pick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 175}} )
                )
              ))
            )
          ) : _react2.default.createElement('div', { className: "chat-language-menu--search--empty", __self: this, __source: {fileName: _jsxFileName, lineNumber: 179}}, "No matching language"  )
        )
      )
    )
  )
}







/* One patient of a household: their name and language, their own picker
 * and Stop translating. Changes keep the modal open,
 * so staff can set each patient in turn. */
const HouseholdPatient = _react.memo.call(void 0, function HouseholdPatient ({
  conversationKey, patient, run,
}) {
  const patientKey = patient.PatientKey
  const name = patient.Name || 'Patient'

  const setLanguage = _react.useCallback.call(void 0, (language) => run(
    () => _actions2.default.setPatientTranslation({
      ConversationKey: conversationKey,
      PatientKey: patientKey,
      Language: language,
      AlwaysTranslate: _translation.alwaysTranslates.call(void 0, language),
    }),
  ), [run, conversationKey, patientKey])

  const onStop = _react.useCallback.call(void 0, () => run(
    () => _actions2.default.stopTranslating({ ConversationKey: conversationKey, PatientKey: patientKey }),
  ), [run, conversationKey, patientKey])

  return (
    _react2.default.createElement('section', { className: "chat-language-menu--patient", 'aria-label': name, __self: this, __source: {fileName: _jsxFileName, lineNumber: 215}}
      , _react2.default.createElement('div', { className: "chat-language-menu--patient--header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 216}}
        , _react2.default.createElement('span', { className: "chat-language-menu--patient--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 217}},  name )
        , _react2.default.createElement('span', { className: "chat-language-menu--patient--language", __self: this, __source: {fileName: _jsxFileName, lineNumber: 218}},  _translation.patientLanguageLabel.call(void 0, patient) )
      )
      , _react2.default.createElement(LanguageRow, {
        groupLabel: `Language for ${name}`,
        conversationKey: conversationKey,
        patientKey: patientKey,
        language: patient.Language,
        onPick: setLanguage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 220}}
      )
      ,  patient.AlwaysTranslate && (
        _react2.default.createElement('div', { className: "chat-language-menu--patient-actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 228}}
          , _react2.default.createElement('div', { className: "chat-language-menu--control", __self: this, __source: {fileName: _jsxFileName, lineNumber: 229}}
            , _react2.default.createElement('p', { className: "chat-language-menu--help", __self: this, __source: {fileName: _jsxFileName, lineNumber: 230}}, "Stops automatic translation for "    , name, " across chats. Saved translations stay available."      )
            , _react2.default.createElement('button', { type: "button", className: "chat-language-menu--item secondary" , 'aria-label': `Stop translating for ${name}`, onClick: onStop, __self: this, __source: {fileName: _jsxFileName, lineNumber: 231}}, "Stop automatic translation"

            )
          )
        )
      )
    )
  )
})

/* The modal's body. It unmounts with the modal, so the search starts over
 * each time it opens. */
const LanguagePicker = ({ conversationKey, onClose }) => {
  const state = _hooks.useAppSelector.call(void 0, s => _translation.selectConversationTranslation.call(void 0, s, conversationKey))
  const patients = _react.useMemo.call(void 0, () => _translation.getChatPatients.call(void 0, state), [state])
  const isHousehold = patients.length > 1
  const patientName = _hooks.useAppSelector.call(void 0, s => _optionalChain([state, 'optionalAccess', _7 => _7.PatientKey])
    ? _translation.patientShortName.call(void 0, _peers.selectPatientByKey.call(void 0, s, state.PatientKey))
    : _translation.patientShortName.call(void 0, null))
  const { showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )

  const warn = _react.useCallback.call(void 0, () => showWarningBar(FAILED_NOTICE), [showWarningBar])
  // One patient: a change closes the modal, as it always has.
  const run = _react.useCallback.call(void 0, (command) => {
    onClose()
    command().catch(warn)
  }, [onClose, warn])
  // A household: per-patient changes keep it open.
  const runInPlace = _react.useCallback.call(void 0, (command) => {
    command().catch(warn)
  }, [warn])

  const setLanguage = _react.useCallback.call(void 0, (language) => run(
    () => _actions2.default.setPatientTranslation({
      ConversationKey: conversationKey,
      Language: language,
      AlwaysTranslate: _translation.alwaysTranslates.call(void 0, language),
    }),
  ), [run, conversationKey])

  const onStop = _react.useCallback.call(void 0, () => run(
    () => _actions2.default.stopTranslating({ ConversationKey: conversationKey }),
  ), [run, conversationKey])

  if (!_translation.shouldShowTranslationControls.call(void 0, state)) return null

  if (isHousehold) {
    return (
      _react2.default.createElement('div', { className: "chat-language-menu--popup", __self: this, __source: {fileName: _jsxFileName, lineNumber: 279}}
        ,  patients.map(patient => (
          _react2.default.createElement(HouseholdPatient, {
            key: patient.PatientKey,
            conversationKey: conversationKey,
            patient: patient,
            run: runInPlace, __self: this, __source: {fileName: _jsxFileName, lineNumber: 281}}
          )
        ))
      )
    )
  }

  const language = state.Language
  // "Vietnamese · translation off": a saved language that isn't translating.
  const languageLabel = patients[0] ? _translation.patientLanguageLabel.call(void 0, patients[0]) : undefined
  const isSavedButOff = !!language && language !== 'en' && !_optionalChain([patients, 'access', _8 => _8[0], 'optionalAccess', _9 => _9.Translating])

  return (
    _react2.default.createElement('div', { className: "chat-language-menu--popup", __self: this, __source: {fileName: _jsxFileName, lineNumber: 298}}
      ,  isSavedButOff && (
        _react2.default.createElement('div', { className: "chat-language-menu--status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 300}},  languageLabel )
      )
      , _react2.default.createElement('div', { className: "chat-language-menu--intro", __self: this, __source: {fileName: _jsxFileName, lineNumber: 302}}
        , _react2.default.createElement('h2', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 303}}, "Patient language" )
        , _react2.default.createElement('p', { className: "chat-language-menu--help", __self: this, __source: {fileName: _jsxFileName, lineNumber: 304}}, "Detected is a suggestion. Selected is the saved language."        )
        , _react2.default.createElement('div', { className: "chat-language-menu--current", __self: this, __source: {fileName: _jsxFileName, lineNumber: 305}}, "Selected: " , _react2.default.createElement('strong', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 305}}, language ? _translation.languageName.call(void 0, language) : 'Not set'))
      )
      , _react2.default.createElement(LanguageRow, { groupLabel: "Language", conversationKey: conversationKey, language: language, onPick: setLanguage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 307}} )
      ,  state.AlwaysTranslate && (
        _react2.default.createElement('section', { className: "chat-language-menu--controls", 'aria-label': "Patient translation settings"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 309}}
          , _react2.default.createElement('div', { className: "chat-language-menu--control", __self: this, __source: {fileName: _jsxFileName, lineNumber: 310}}
            , _react2.default.createElement('div', { className: "chat-language-menu--control-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 311}}, "Automatic translation for "   , patientName)
            , _react2.default.createElement('p', { className: "chat-language-menu--help", __self: this, __source: {fileName: _jsxFileName, lineNumber: 312}}, "Stops automatic translation for "    , patientName, " across chats. Saved translations stay available."      )
            , _react2.default.createElement('button', { type: "button", className: "chat-language-menu--item secondary" , 'aria-label': `Stop translating for ${patientName}`, onClick: onStop, __self: this, __source: {fileName: _jsxFileName, lineNumber: 313}}, "Stop automatic translation"

            )
          )
        )
      )
    )
  )
}

/* "Language" from a patient chat's options menu: each patient's language
 * and Stop translating. A household (two or
 * more patients) lists every patient by name with their own controls. */
const LanguageModal = ({ isOpen, onClose, conversationKey }) => (
  _react2.default.createElement(_Modal2.default, {
    title: "Language",
    className: "chat-language-modal",
    bodyClassName: "chat-language-modal--body",
    size: "xs",
    isOpen: isOpen,
    onClose: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 327}}

    , _react2.default.createElement(LanguagePicker, { conversationKey: conversationKey, onClose: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 335}} )
  )
)

exports. default = _react.memo.call(void 0, LanguageModal)
